import PageNotFound from '@pages/page-not-found/page-not-found';
export default PageNotFound;
